const topicsData = [
  { id: 1, name: '顶流塌房', heat: '1256w', trend: 'up' },
  { id: 2, name: '综艺翻车', heat: '980w', trend: 'up' },
  { id: 3, name: '网红人设崩塌', heat: '876w', trend: 'up' },
  { id: 4, name: '明星恋情曝光', heat: '765w', trend: 'hot' },
  { id: 5, name: '影视剧吐槽', heat: '654w', trend: 'up' },
  { id: 6, name: '音乐抄袭争议', heat: '543w', trend: 'hot' },
  { id: 7, name: '直播翻车现场', heat: '432w', trend: 'up' },
  { id: 8, name: '娱乐圈税务', heat: '389w', trend: 'down' },
  { id: 9, name: '选秀内定黑幕', heat: '321w', trend: 'up' },
  { id: 10, name: '代言品牌暴雷', heat: '298w', trend: 'hot' },
  { id: 11, name: '明星解约风波', heat: '267w', trend: 'up' },
];

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  hot: 'ri-fire-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  down: 'text-foreground-400',
  hot: 'text-accent-500',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            话题热搜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在追的吃瓜话题，热度实时更新</p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap gap-3 justify-center">
          {topicsData.map((topic) => (
            <span
              key={topic.id}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-full cursor-pointer hover:border-primary-300 hover:bg-primary-50/50 transition-colors group whitespace-nowrap"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
              <span className={`text-xs ${trendColors[topic.trend] || 'text-foreground-400'}`}>
                <i className={trendIcons[topic.trend] || 'ri-subtract-line'}></i>
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}